<template>
  <form class="supplier-contact-form" v-on:submit.prevent>
    <loading v-if="loading"></loading>
    <div v-else-if="this.lastRequest">
      Last requested: <b>{{ lastRequest.createdAt | date }}</b>
    </div>
    <validated-input label="Name" validate="required|max:1000" v-model="name" />
    <validated-input label="Company" validate="required|max:1000" v-model="company" />
    <validated-input label="Email" validate="required|max:1000" v-model="email" />
    <validated-input label="Phone" v-model="phone" />
    <validated-input label="Block Id" v-model="blockId" validate="required|max:1000" />
    <validated-input label="Company Id" v-model="companyId" validate="required|max:1000" />
    <div class="form-group mt-3">
      <label>Message</label>
      <textarea
        v-model="message"
        type="text"
        class="form-control"
        placeholder="message..."
        autofocus
        rows="10"
      ></textarea>
    </div>

    <button class="btn btn-primary mt-3 mb-4" @click="request" :disabled="errors.any() || submitting">
      <i v-if="submitting" class="far fa-spinner-third fa-spin"></i> Submit
    </button>
  </form>
</template>
<script>
import { encodeOpts } from '@/utils/encode-opts';
export default {
  name: 'ModalForm',
  props: {
    supplier: Object
  },
  inject: ['$validator'],
  data() {
    return {
      loading: false,
      lastRequest: null,
      submitting: false,
      email: 'promostandards@mpowerpromo.com',
      name: this.$store.getters['loggedInUser'].distributorId.name || 'MPower Promo Inc',
      company: this.$store.getters['loggedInUser'].distributorId.name || 'MPower Promo Inc',

      industry: 'ASI 278165',
      phone: '435-557-0445',
      message:
        'We would like to request access to your Promo Standards API’s.  We are a SaaS provider for decorators and distributors https://mpowerpromo.com',
      endpoints: [this.supplier.ps_service_id],
      blockId: 90,
      companyId: this.supplier.ps_company_id
    };
  },
  async mounted() {
    try {
      this.loading = true;
      const { data } = await this.$http.get(`/logs`, {
        params: { parent: [{ parent: this.supplier._id }], typeModel: 'suppliers', limit: 1 },
        paramsSerializer: encodeOpts
      });
      this.lastRequest = data.data[0];
    } catch (e) {
    } finally {
      this.loading = false;
    }
  },
  methods: {
    async request(e) {
      this.submitted = true;

      try {
        e.preventDefault();
        await this.$validator.validateAll();
        if (this.errors.any()) {
          this.submitted = false;
          return;
        }
        this.submitting = true;

        await this.$http.post(`/suppliers/${this.supplier._id}/ps-request-cred`, {
          name: this.name,
          company: this.company,
          email: this.email,
          phone: this.phone,
          message: this.message,
          endpoints: this.endpoints,
          blockId: this.blockId,
          companyId: this.companyId
        });
        this.notifySuccess('Supplier cred requests');
      } catch (e) {
        this.notifyError(e.message || e);
      } finally {
        this.submitting = false;
      }
    }
  }
};
</script>
